// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"6c6b4318","94":"42347457"}[chunkId] + ".chunk.css";
};